<div fxLayout="row">
  <mat-form-field #theFormField fxFlex="1 1 auto">
    <mat-label>{{ label }}</mat-label>
    <input
      #theInput
      matInput
      [formControl]="formCtrl"
      [placeholder]="placeholder"
      [readonly]="(editMode | async) === false"
      (keydown.enter)="updateValue($event)"
      (keydown.esc)="cancelEdit($event)"
    />
    <mat-error *ngIf="formCtrl.invalid && formCtrl.errors.message">{{formCtrl.errors.message | translate}}</mat-error>
    <mat-error *ngIf="formCtrl.invalid && formCtrl.errors.required">{{'validator.required.error' | translate}}</mat-error>
  </mat-form-field>
  <div fxLayoutAlign="end" *ngIf="!readOnly">
    <button mat-icon-button class="edit-button" *ngIf="(editMode | async) === false" (click)="editAttribute()" matTooltip="{{'global.edit' | translate}}">
      <mat-icon>edit</mat-icon>
    </button>
    <button mat-icon-button class="cancel-button" *ngIf="(editMode | async) === true" (click)="cancelEdit()" matTooltip="{{'global.cancel' | translate}}">
      <mat-icon>cancel</mat-icon>
    </button>
    <button mat-icon-button class="save-button" *ngIf="(editMode | async) === true" (click)="updateValue()" [disabled]="formCtrl.invalid" matTooltip="{{'global.save' | translate}}">
      <mat-icon>save</mat-icon>
    </button>
  </div>
</div>
